
import React from 'react';
import { Link } from 'react-router-dom';
import { Trek } from '@/lib/types/trek-types';
import { MapPin, ArrowRight } from 'lucide-react';

interface SearchTrekResultsProps {
  results: Trek[];
  searchQuery: string;
  onResultClick: (trekId: string) => void;
  highlightedIndex: number;
  startIndex: number;
  onMouseEnter: (index: number) => void;
}

const SearchTrekResults: React.FC<SearchTrekResultsProps> = ({
  results,
  searchQuery,
  onResultClick,
  highlightedIndex,
  startIndex,
  onMouseEnter
}) => {
  if (results.length === 0) return null;

  return (
    <div>
      <div className="px-4 py-2 text-xs font-semibold text-muted-foreground border-t border-b border-border bg-muted/20">
        Trek Results
      </div>
      <ul>
        {results.map((trek, index) => (
          <li 
            key={trek.id}
            className={`px-4 py-3 flex items-center gap-3 cursor-pointer hover:bg-muted transition-colors ${
              index + startIndex === highlightedIndex ? 'bg-muted' : ''
            }`}
            onClick={() => onResultClick(trek.id)}
            onMouseEnter={() => onMouseEnter(index + startIndex)}
          >
            <div className="h-12 w-12 rounded-md overflow-hidden flex-shrink-0">
              <img 
                src={trek.images[0]} 
                alt={trek.name} 
                className="h-full w-full object-cover"
              />
            </div>
            <div className="flex-grow min-w-0">
              <div className="font-medium text-sm truncate">{trek.name}</div>
              <div className="flex items-center text-xs text-muted-foreground">
                <MapPin className="h-3 w-3 mr-1" />
                <span className="truncate">{trek.location || 'Location unavailable'}</span>
                <span className="mx-1">•</span>
                <span className="whitespace-nowrap">{trek.difficulty}</span>
              </div>
            </div>
            <ArrowRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchTrekResults;
